export default "__VITE_ASSET__CqUhgbWQ__"